import { useQuery } from "react-query";
import SchemaService from "../api/services/SchemaService";

export const useBondRecordData = (
  productId: string | null,
  accessKey: string | null,
  paymentStatus: string | null
) =>
  useQuery(
    ["bondRecordData", productId, accessKey, paymentStatus],
    async () =>
      await SchemaService.getBondRecordData(
        productId,
        accessKey,
        paymentStatus
      ),
    {
      enabled: false,
      select({ data }) {
        return data?.record;
      },
    }
  );
